export class AbortError extends Error {
    public name = 'AbortError';
}
